import Vue from 'vue';

import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildCreateMutations(['inviteUser']),
  ...buildUpdateMutations(['updateRole', 'resendInvitation']),
  ...buildDeleteMutations(['removeUserMembership']),

  // --- validateInvitationToken action ---
  validateInvitationTokenPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  validateInvitationTokenSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  validateInvitationTokenError: (state) => {
    Vue.set(state, 'processing', false);
  },

  // --- acceptInvitation action ---
  acceptInvitationPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  acceptInvitationSuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  acceptInvitationError: (state) => {
    Vue.set(state, 'processing', false);
  },

  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  openFormModal: (state, payload = null) => {
    Vue.set(state, 'formModalContext', payload);
    Vue.set(state, 'formModalOpened', true);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
    Vue.set(state, 'formModalContext', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/userMembership/mutations.js